module.exports = __webpack_public_path__ + "static/img/penny_pictgrid10_800x797.09a90df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/penny_pictgrid10_800x797.jpg
// module id = 3O8P
// module chunks = 0